module.exports = __webpack_public_path__ + "static/media/jasper-31.57e051b1.jpg";